/**
 * z-index 레이어 시스템
 *
 * UI 요소들의 레이어 순서를 명확하게 정의합니다.
 * 숫자가 클수록 위에 표시됩니다.
 */
export const Z_INDEX = {
  /** 사이드바 (데스크톱) */
  sidebar: 40,
  /** 채널 셀렉터 드롭다운 */
  dropdown: 42,
  /** 모바일 하단 탭바 */
  mobileTabBar: 45,
  /** 오디오 플레이어 (하단 고정) */
  audioPlayer: 50,
  /** 더보기 바텀시트 (모바일) */
  moreMenu: 55,
  /** AppToast 알림 */
  toast: 60,
  /** 모달 오버레이 */
  modalOverlay: 65,
  /** 모달 */
  modal: 70,
  /** 툴팁 */
  tooltip: 80,
} as const;

/**
 * z-index 값 타입
 */
export type ZIndexKey = keyof typeof Z_INDEX;
export type ZIndexValue = (typeof Z_INDEX)[ZIndexKey];

export default Z_INDEX;
